import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { ApiUrlConstant } from "./../../../../constants/api-url.constant";
import { Observable } from "rxjs";
const month = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
@Injectable()
export class TransportationTemperatureAdherenceService {
  baseUrl = environment.baseUrl;
  editItem: any;
  constructor(
    public generic: GenericHttpService,
    private apiUrl: ApiUrlConstant
  ) {}

  getTransferEndToEndSlaTrendData(options): Observable<any> {
    const option = {
      method: "GET",
      url:
        options.url ||
        `${this.baseUrl}${this.apiUrl.transportTemperatureAdherence}`,
      query: options.params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.generic.responseData)
    );
  }
  processTransferEndToEndSlaTrend(data: any) {
    const percentage = [],
      volume = [];
    const labels = data.map(value => {
      const aDate = new Date(value.date);
      percentage.push(value.percentage);
      volume.push(value.volume);
      return `${aDate.getDate()} ${month[aDate.getMonth()]}`;
    });

    return { labels, percentage, volume };
  }

  createChart(chartData, Options) {
    const chart = JSON.parse(JSON.stringify(HSET.chartData));
    chart.series = chartData;
    return chart;
  }
}
